import styled from 'styled-components'
import vars from 'scss/variables.js'

const { white, colorGrey9, colorGrey1 } = vars

export const Container = styled.div`
  display: flex;
  align-items: center;
  background: ${colorGrey9};
  border-radius: 8px 8px 0 0;
  padding: 7px 24px 7px 36px;

  svg {
    margin-left: -7px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
`

export const Info = styled.p`
  display: flex;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: ${white};

  &:after {
    content: '';
    display: block;
    width: 2px;
    height: 18px;
    background: ${colorGrey1};
    margin: 0 16px;
  }
`

export const Button = styled.button`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #ff628c;

  &:hover {
    cursor: pointer;
  }
`
